import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AppLink {
  path: string;
  queryParams: Record<string, string>;
}

@Injectable({ providedIn: 'root' })
export class AppLinkService {
  readonly opened$ = new Subject<AppLink>();

  parse(rawUrl: string): AppLink | null {
    if (!rawUrl) return null;

    try {
      const normalized = rawUrl.includes('://')
        ? rawUrl
        : `https://app.local/${rawUrl.replace(/^\//, '')}`;
      const url = new URL(normalized);
      let path = url.pathname || '/';
      let search = url.searchParams;

      if (url.hash.startsWith('#/')) {
        const hashed = new URL(url.hash.slice(1), 'https://app.local');
        path = hashed.pathname || '/';
        search = hashed.searchParams;
      }

      const httpHost =
        url.hostname.includes('.') || url.hostname === 'localhost';
      if ((!path || path === '/') && url.hostname && !httpHost) {
        path = `/${url.hostname}`;
      }

      if (!path.startsWith('/')) {
        path = `/${path}`;
      }
      if (path.length > 1) {
        path = path.replace(/\/+$/, '');
      }

      const queryParams: Record<string, string> = {};
      search.forEach((value, key) => {
        if (value) queryParams[key] = value;
      });

      if (this.isApkListingPath(path)) {
        return { path: '/admin', queryParams: { ...queryParams, tab: 'builds' } };
      }

      return { path, queryParams };
    } catch {
      return null;
    }
  }

  isApkFileUrl(rawUrl: string): boolean {
    return /\/apk\/(apk|release)\/[^/?#]+\.(apk|aab)(\?|#|$)/i.test(rawUrl || '');
  }

  isApkListingUrl(rawUrl: string): boolean {
    if (this.isApkFileUrl(rawUrl)) return false;
    return /\/apk\/(apk|release)\/?(\?|#|$)/i.test(rawUrl || '');
  }

  isApkListingPath(path: string): boolean {
    return /^\/apk\/(apk|release)$/i.test(path || '');
  }
}
